import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';

export const initialState = {
  currentLang: `${localStorage.getItem("lang") || (Cookies.get("language") || "fr")}`,
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    updateCurrentLang: (state: { currentLang: string }, action) => ({ currentLang: action.payload }),
  },
});

export const languageActions = languageSlice.actions;

export default languageSlice.reducer;
